import { ReactElement } from 'react'
import { Chip, Tooltip } from '@mui/material'
import type { PdfTargetViewer } from '@api/fastAPI.schemas'
import { getTargetViewerLabel } from '../../constants'

interface Props {
  targetViewer: PdfTargetViewer
}

/** Small label on a plan row: the PDF viewer the plan was optimised for ("Optimiert für"). */
const PlanTargetViewerChip = ({ targetViewer }: Props): ReactElement => {
  const label = getTargetViewerLabel(targetViewer)

  return (
    <Tooltip title={`Für ${label} optimiert`}>
      <Chip
        label={label}
        size="small"
        variant="outlined"
        sx={{
          ml: 0.75,
          height: 16,
          fontSize: 10,
          verticalAlign: 'middle',
          '& .MuiChip-label': { px: 0.75 },
        }}
        data-cy="plan-view-plan-target-viewer"
      />
    </Tooltip>
  )
}

export default PlanTargetViewerChip
